/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Alpha_Status_ExportingInputs */

const en_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting video with alpha channel...`)
};

const fr_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation video avec canal alpha...`)
};

const de_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoexport mit Alphakanal...`)
};

const it_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione video con canale alfa...`)
};

const ru_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видео с альфа-каналом...`)
};

const es_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando vídeo con canal alfa...`)
};

const zh_cn2_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出带透明度通道的视频……`)
};

const ja_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アルファ チャンネル付きのビデオをエクスポートしています...`)
};

const hi_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अल्फा चैनल सहित वीडियो निर्यात किया जा रहा है...`)
};

const pt_pt2_video_export_alpha_status_exporting = /** @type {(inputs: Video_Export_Alpha_Status_ExportingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando vídeo com canal alfa...`)
};

/**
* | output |
* | --- |
* | "Exporting video with alpha channel..." |
*
* @param {Video_Export_Alpha_Status_ExportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_alpha_status_exporting = /** @type {((inputs?: Video_Export_Alpha_Status_ExportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Alpha_Status_ExportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_alpha_status_exporting(inputs)
	if (locale === "de") return de_video_export_alpha_status_exporting(inputs)
	if (locale === "it") return it_video_export_alpha_status_exporting(inputs)
	if (locale === "ru") return ru_video_export_alpha_status_exporting(inputs)
	if (locale === "es") return es_video_export_alpha_status_exporting(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_alpha_status_exporting(inputs)
	if (locale === "ja") return ja_video_export_alpha_status_exporting(inputs)
	if (locale === "hi") return hi_video_export_alpha_status_exporting(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_alpha_status_exporting(inputs)
	return en_video_export_alpha_status_exporting(inputs)
});